export const view = view => () => import(/* webpackChunkName: "js/backoffice/views/[request]" */ `@/views/${view}`)
